import { createContext, FC } from 'react';

export type ImportDeclarationProps = {
  onSubmitSucceed?: () => void;
  onClose?: () => void;
};

export const ImportDeclarationContext = createContext<ImportDeclarationProps>({
  onSubmitSucceed: () => {},
  onClose: () => {},
});

export const ImportDeclarationProvider: FC<ImportDeclarationProps> = ({ children, onSubmitSucceed, onClose }) => {
  return <ImportDeclarationContext.Provider value={{ onSubmitSucceed, onClose }}>{children}</ImportDeclarationContext.Provider>;
};
